<template>
  <el-dialog
    :title="dispute ? `Dispute${dispute.attendance_record ? ' - ' + getFullName(dispute.attendance_record.user) : ''}` : ''"
    :visible.sync="dialogVisible"
    width="80%"
    :fullscreen="$mq === 'xs'"
  >
    <div class="profile" v-if="dispute">
      <div v-if="!editing && dispute != null">
        <div class="section-header">
          <div class="title">Info</div>
          <div class="divider"></div>
        </div>
        <div style="margin-right: 16px; margin-left: 16px;">
          <div class="flex">
            <span class="mgra sub-header">Type</span>
            <span>{{ dispute.dispute_type.name }}</span>
          </div>
          <div class="flex">
            <span class="mgra sub-header">Event</span>
            <span>{{ dispute.attendance_record.event.event_type.name + ' - ' + dispute.attendance_record.event.date }}</span>
          </div>
          <div class="flex">
            <span class="mgra sub-header">Message</span>
            <span>{{ dispute.dispute_reason }}</span>
          </div>
          <div class="flex">
            <span class="mgra sub-header">File</span>
            <span v-if="dispute.filename != null" class="link">
              <a @click="showAttachment(dispute.o_id)">Show</a>
            </span>
            <span v-else>N/A</span>
          </div>
        </div>
        <div v-if="dispute.is_finalized != null" class="section-header">
          <div class="title">Finalize</div>
          <div class="divider"></div>
        </div>
        <div v-if="dispute.is_finalized != null" style="margin-right: 16px; margin-left: 16px;">
          <div class="flex">
            <span class="mgra sub-header">Is Finalized</span>
            <span>{{ !!dispute.is_finalized }}</span>
          </div>
          <div class="flex">
            <span class="mgra sub-header">User</span>
            <span>{{ getFullName(dispute.user_finalized) }}</span>
          </div>
          <div class="flex">
            <span class="mgra sub-header">Comment</span>
            <span>{{ dispute.finalized_comment }}</span>
          </div>
        </div>
        <div v-if="dispute.is_approved != null" class="section-header">
          <div class="title">Approval</div>
          <div class="divider"></div>
        </div>
        <div v-if="dispute.is_approved != null" style="margin-right: 16px; margin-left: 16px;">
          <div class="flex">
            <span class="mgra sub-header">Is Approved</span>
            <span>{{ !!dispute.is_approved }}</span>
          </div>
          <div class="flex">
            <span class="mgra sub-header">User</span>
            <span>{{ getFullName(dispute.user_approved) }}</span>
          </div>
          <div v-if="dispute.approved_comment != null" class="flex">
            <span class="mgra sub-header">Comment</span>
            <span>{{ dispute.approved_comment }}</span>
          </div>
        </div>
        <div v-if="finalize || approve">
          <hr />
          <el-input
            class="no-border"
            type="textarea"
            v-model="dispute.message"
            :autosize="{ minRows: 10, maxRows: 20}"
            placeholder="Comments..."
          ></el-input>
        </div>
      </div>
      <div v-else>
        <div class="flex">
          <span class="mgra sub-header">Event</span>
          <span>{{ dispute.event ? `${dispute.event.event_type.name} - ${dispute.event.date}`: `${dispute.attendance_record.event.event_type.name} - ${dispute.attendance_record.event.date}` }}</span>
        </div>
        <el-form :model="dispute" :rules="rules" ref="ruleForm">
          <el-form-item prop="type">
            <el-select style="width:100%;" v-model="dispute.type" placeholder="Type">
              <el-option
                v-for="item in disputeTypes"
                :key="item.o_id"
                :label="item.name"
                :value="item.o_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="message">
            <el-input
              class="no-border"
              type="textarea"
              v-model="dispute.message"
              :autosize="{ minRows: 10, maxRows: 20}"
              placeholder="Message..."
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-if="editing">
        <hr />
        <el-checkbox v-model="attachment" :disabled="reattach">Attachment</el-checkbox>
        <el-checkbox
          v-if="dispute.event.attendance[0].dispute_records.length > 0 &&
            dispute.event.attendance[0].dispute_records[0].filename !== null"
          v-model="reattach"
          :disabled="attachment">
          Use previous dispute attachment (<a @click="showAttachment(dispute.event.attendance[0].dispute_records[0].o_id)">Show</a>)
        </el-checkbox>
        <el-upload
          v-if="attachment"
          ref="upload"
          drag
          :http-request="saveDispute"
          action="/api/v1/attendance/disputes"
          :auto-upload="false"
          style="width:100%"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            Drop file here or
            <em>click to upload</em>
          </div>
          <div class="el-upload__tip" slot="tip">Upload supporting documentation.</div>
        </el-upload>
      </div>
    </div>
    <div style="margin-top: 8px; display: flex; justify-content: space-between;">
      <div>
        <el-button v-if="!editing || !finalize || !approve" @click="close" size="small">Close</el-button>
        <el-button v-else @click="close" size="small">Cancel</el-button>
      </div>
      <div>
        <el-button v-if="editing" @click="saveDispute" type="primary" size="small">Submit</el-button>
        <el-button-group v-if="finalize">
          <el-button @click="finalizeDispute(false)" type="danger" plain size="small">Deny</el-button>
          <el-button @click="finalizeDispute(true)" type="success" plain size="small">Finalize</el-button>
        </el-button-group>
        <span v-if="approve">
          <el-popover placement="bottom" width="160" trigger="click">
            <p>Is this redisputable?</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="approveDispute(false, false)">No</el-button>
              <el-button type="primary" size="mini" @click="approveDispute(false, true)">Yes</el-button>
            </div>
            <el-button slot="reference" type="danger" plain size="small">Deny</el-button>
          </el-popover>
          <el-button @click="approveDispute(true, false)" type="success" plain size="small">Approve</el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    name: "nxs-dispute-modal",
    props: {
        finalize: {default: false},
        creating: {default: false},
        approve: {default: false},
        event: {default: null},
        value: {required: true}
    },
    data() {
        return {
            editing: this.creating,
            attachment: false,
            reattach: false,
            dialogVisible: false,
            dispute: this.value,
            rules: {
                type: [
                    {required: true, message: "Please select type.", trigger: "blur"}
                ],
                event: [
                    {
                        required: true,
                        message: "Please select absence.",
                        trigger: "change"
                    }
                ],
                message: [
                    {
                        required: true,
                        message: "Please write a message.",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    watch: {
        value() {
            this.dispute = this.value;
        },
        creating(value) {
            this.editing = value;
        }
    },
    computed: {...mapFields(["user", "users", "events", "disputable", "disputeTypes"])},
    mounted() {
        if (this.events == null) this.$store.dispatch("pullEvents");
        if (this.disputeTypes == null) this.$store.dispatch("pullDisputeTypes");
    },
    methods: {
        edit() {
            this.editing = true;
        },
        showAttachment(id) {
            window.open("/admin/disputes/" + id + "/attachment");
        },
        finalizeDispute(finalized) {
            this.axios
                .put(
                    "/api/v1/attendance/disputes/" + this.dispute.o_id,
                    {
                        is_finalized: finalized,
                        finalized_comment: this.dispute.message
                    },
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then((response) => {
                    this.save(response.data);
                    this.$message({
                        showClose: true,
                        message: "Dispute updated successfully",
                        type: "success"
                    });
                })
                .catch((err) => {
                    console.error(err);
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        approveDispute(approved, redisputable) {
            this.axios
                .put(
                    "/api/v1/attendance/disputes/" + this.dispute.o_id,
                    {
                        is_approved: approved,
                        approved_comment: this.dispute.message,
                        is_redisputable: redisputable
                    },
                    {
                        headers: {"Content-Type": "application/json"},
                        credentials: "same-origin"
                    }
                )
                .then((response) => {
                    this.save(response.data);
                    this.$message({
                        showClose: true,
                        message: "Dispute updated successfully",
                        type: "success"
                    });
                })
                .catch((err) => {
                    console.error(err);
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        saveDispute(param) {
            var t = true;
            this.$refs.ruleForm.validate((valid) => {
                t = valid;
                return valid;
            });
            if (!t) {
                return;
            }
            if (param.file == null && this.attachment) {
                this.$refs.upload.submit();
                return;
            }
            const data = new FormData();
            if (param.file != null) {
                data.append("qqfile", param.file, param.file.name);
            }

            data.append("attendance_id", this.dispute.event.attendance[0].o_id);
            data.append("dispute_type", this.dispute.type);
            data.append("dispute_reason", this.dispute.message);
            if (this.reattach) {
              data.append('reattach_document', this.reattach ? 1 : 0);
            }

            this.axios
                .post("/api/v1/attendance/disputes", data, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.save(response.data);
                    this.$message({
                        showClose: true,
                        message: "Dispute submitted successfully",
                        type: "success"
                    });
                })
                .catch((err) => {
                    console.error(err);
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        },
        save(value) {
            this.editing = false;
            this.$emit("input", value);
            this.$emit("save", value);
            this.close();
        },
        close() {
            this.dialogVisible = false;
            this.$emit("close");
        },
        open() {
            this.dialogVisible = true;
        }
    }
};
</script>

